import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  section: FelaCSS;
  wrapper: FelaCSS;
  header: FelaCSS;
  grid: FelaCSS;
}

const styles = (): IStyles => ({
  section: {
    marginBottom: 6,
    background: colors.space04,

    desktopDesign: {
      background: colors.white,
    },
  },

  wrapper: {
    background: colors.white,
    borderRadius: '8px',
    margin: 3,
    padding: 3,

    desktopDesign: {
      margin: 0,
      background: colors.space04,
    },
  },

  header: {
    fontDefaultSemiBold: 16,
    marginBottom: 3,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: '1px',
    rowGap: '1px',
    borderRadius: '8px',
    overflow: 'hidden',
  },
});

export default styles;
